import { axiosPrivate } from "@app/dashboard/tools/axios/axiosInstance";
import { LOCAL_STORAGE_KEYS } from "@app/dashboard/constants/local-storage-keys";
import { environment } from "@app/dashboard/environments/environment";
import { addToLocalStorage } from "@app/dashboard/utils/manageLocalStorage";

export const checkActiveServices = async () => {
  try {
    const response = await axiosPrivate.get(`/dashboard/api/v1/services/`);
    const services = response.data.results;

    services?.length &&
      services.forEach((service: any) => {
        const { service_name, active, service_id } = service;
        const serviceInfo = {
          enabled: active,
          id: service_id
        };

        (service_name === environment.STATEMENTS_SERVICE_NAME || service_name === environment.STATEMENTS_SERVICE_NAME_ALPHA) && 
          addToLocalStorage(LOCAL_STORAGE_KEYS.MERCHANT_STATEMENTS, serviceInfo);

        service_name === environment.DIGEST_SERVICE_NAME && 
          addToLocalStorage(LOCAL_STORAGE_KEYS.DIGEST, serviceInfo);
      });

    return response;
  } catch (error) {
    return Promise.reject(error);
  }
};